import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// can you remove this @Shajansheriff why do we need this?
import ChevronDown20 from '@carbon/icons-react/es/chevron--down/20';
import Close16 from '@carbon/icons-react/es/close/16';
import Close20 from '@carbon/icons-react/es/close/20';
import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
// eslint-disable-next-line no-restricted-imports
import { getRandomColor } from '@rocketlane/ui';
import { List } from 'antd';
import classNames from 'classnames';
import { debounce } from 'lodash';
import React, { forwardRef, useCallback, useRef } from 'react';
import ReactSelect, { components as RsComponents, createFilter, defaultTheme } from 'react-select';
import AsyncReactSelect from 'react-select/async';
import ReactAsyncCreatableSelect from 'react-select/async-creatable';
import ReactCreatableSelect from 'react-select/creatable';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { UserStatus } from 'api/models';
import { HeightStyle } from 'components/atoms/input/input';
import { TaskName } from 'components/organisms/templates/commons/task-name-simple';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { useAiAgentFeatureFlag } from 'hooks/use-ai-agent';
import { useUserSwr } from 'hooks/use-swr-user-hooks';
import { useTranslate } from 'hooks/use-translation';
import { fullName } from 'utils/full-name';
import { SingleLineEllipsis } from '../../styles';
import { Avatar } from '../avatar';
import { Tag as TagAtom } from '../tag';
import { StyledDropdownIndicator } from './components';
import { AvatarOption, CurrencyOption } from './custom-components';
export const selectPrefix = 'ozone-select';
export var InputChangeActions = /*#__PURE__*/ function(InputChangeActions) {
    InputChangeActions["InputBlur"] = "input-blur";
    InputChangeActions["MenuClose"] = "menu-close";
    return InputChangeActions;
}({});
const Tag = styled(TagAtom)`
  padding: 0 var(--spacing-02) 0 0;
  max-width: ${({ $maxWidth })=>$maxWidth || undefined};
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const StyleAvatar = styled(Avatar)`
  margin-right: var(--spacing-03);
  flex-shrink: 0;

  &.disabled {
    opacity: 0.5;
  }
`;
const MultiValueTagWrapper = styled.span`
  margin-left: var(--spacing-01);
  margin-right: var(--spacing-01);
  min-width: 0;
  max-width: 100%;
`;
const Ellipsis = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const UserTag = ({ color = 'gray', imageUrl, label, companyLogoUrl, icon, userStatus, hideAvatar, children, maxWidth, ...tagProps })=>{
    const hasAiAgentFeatures = useAiAgentFeatureFlag();
    return /*#__PURE__*/ _jsx(Tag, {
        ...tagProps,
        color: color,
        "data-cy": `tag-value-${label}`,
        $maxWidth: maxWidth,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                !hideAvatar && /*#__PURE__*/ _jsx(StyleAvatar, {
                    size: "small",
                    companyLogoUrl: companyLogoUrl,
                    ...icon ? {
                        icon
                    } : {
                        name: label,
                        src: imageUrl
                    },
                    className: userStatus === UserStatus.Inactive ? 'disabled' : '',
                    userStatus: userStatus
                }),
                /*#__PURE__*/ _jsx(Ellipsis, {
                    title: label,
                    children: label
                }),
                hasAiAgentFeatures ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: children
                }) : null
            ]
        })
    });
};
export const UserTagWithSwr = ({ userId })=>{
    const user = useUserSwr(userId);
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ _jsx(UserTag, {
        ...user,
        imageUrl: user === null || user === void 0 ? void 0 : user.photoUrl,
        color: getRandomColor(fullName(user)),
        label: fullName(user),
        userStatus: user === null || user === void 0 ? void 0 : user.userStatus
    });
};
export const DropdownIndicator = (props)=>{
    return /*#__PURE__*/ _jsx(StyledDropdownIndicator, {
        ...props,
        children: /*#__PURE__*/ _jsx(ChevronDown20, {})
    });
};
export const StyledControl = styled(RsComponents.Control).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})`
  outline: 2px solid !important;
  outline-color: transparent !important;
  outline-offset: -2px;
  border: 0;
  border-bottom: 1px solid var(--gray-50);
  border-radius: 0;
  background-color: var(--gray-10);
  min-height: ${HeightStyle};
  padding: 2px;

  :global(:root[data-new-theme-enabled='true']) & {
    padding: 1px;
  }

  .ozone-select__value-container {
    max-height: calc(3 * ${HeightStyle});
    /* overflow-y: scroll; */
    display: flex;
  }
  .ozone-select__placeholder {
    position: absolute;
  }

  ${ifProp('isFocused', css`
      box-shadow: none;
      border-bottom-color: transparent !important;
      outline-color: var(--primary-color) !important;
    `)};
  &:hover {
    background-color: var(--hover-color);
  }
`;
export const RocketlaneUIControl = styled(RsComponents.Control).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})`
  outline: 2px solid !important;
  outline-color: transparent !important;
  outline-offset: -2px;
  border: 1px solid var(--scarlet-gray-60);
  border-radius: var(--spacing-03);
  min-height: var(--height-base);
  height: ${(props)=>props.isMulti ? 'auto' : 'var(--height-base)'};
  padding: 0;

  .ozone-select__value-container {
    max-height: calc(3 * ${HeightStyle});
    overflow-y: ${(props)=>props.isMulti ? 'auto' : 'hidden'};
    display: flex;
    align-items: ${(props)=>props.isMulti ? 'flex-start' : 'center'};
    align-content: ${(props)=>props.isMulti ? 'flex-start' : 'center'};
    padding: 0px var(--padding-01);
    height: ${(props)=>props.isMulti ? undefined : '100%'};
    flex-wrap: ${(props)=>props.isMulti ? 'wrap' : 'nowrap'};
    gap: ${(props)=>props.isMulti ? 'var(--padding-xs)' : '0'};
  }
  .ozone-select__placeholder {
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }
  .ozone-select__single-value {
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }
  .ozone-select__input-container {
    margin: 0;
    padding: 0;
    align-self: center;
  }
  .ozone-select__input {
    margin: 0;
    padding: 0;
  }
  .ozone-select__indicators {
    align-self: center;
    height: 100%;
    display: flex;
    align-items: center;
  }

  ${ifProp('isFocused', css`
      box-shadow: none;
      border-bottom-color: transparent !important;
      outline-color: var(--scarlet-gray-100) !important;
    `)};
  &:hover {
    border: 1px solid var(--scarlet-gray-90);
  }
`;
export const StyledClear = styled(RsComponents.ClearIndicator).attrs({
    theme: {
        ...defaultTheme
    }
})`
  margin-right: var(--spacing-01);
  &:hover {
    color: var(--gray-100);
    background-color: var(--black-with-opacity);
    border-radius: var(--border-radius-default);
    cursor: pointer;
  }
  [data-new-theme-enabled='true'] & {
    border-radius: var(--border-radius-small);
  }
`;
export const Control = (props)=>/*#__PURE__*/ _jsx(StyledControl, {
        ...props
    });
export const ClearIndicator = (props)=>{
    const isNew = useAntdRlUISwitcher();
    const Newbutton = isNew ? Close16 : Close20;
    return /*#__PURE__*/ _jsx(StyledClear, {
        ...props,
        children: /*#__PURE__*/ _jsx(Newbutton, {})
    });
};
const ListItem = styled(List.Item)`
  padding: 0 !important;
  :root[data-new-theme-enabled='true'] & {
    padding-left: var(--padding-xs);
    padding-right: var(--padding-xs);
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    min-height: var(--height-base);
    height: var(--height-base);
    display: flex;
    align-items: center;
  }
`;
const ListItemMeta = styled(List.Item.Meta)`
  align-items: center;

  & .ant-list-item-meta-title {
    margin-bottom: 0;
    color: var(--gray-100);
  }

  & .ant-list-item-meta-description {
    font-size: var(--font-size-sm);
    color: var(--gray-80);
    font-weight: normal;
  }
  :root[data-new-theme-enabled='true'] & {
    padding-left: var(--padding-xs);
    padding-right: var(--padding-xs);
    padding-top: 0 !important;
    padding-bottom: 0 !important;

    & .ant-list-item-meta-content {
      display: flex;
      align-items: center;
    }
  }
`;
const StyledOption = styled(RsComponents.Option).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})``;
const Option = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledOption, {
        ...props,
        children: /*#__PURE__*/ _jsx(ListItem, {
            children: /*#__PURE__*/ _jsx(ListItemMeta, {
                avatar: /*#__PURE__*/ _jsx(Avatar, {
                    name: data.__isNew__ ? data.value : data.label,
                    src: data.imageUrl,
                    userStatus: data === null || data === void 0 ? void 0 : data.userStatus
                }),
                title: data.label,
                description: data.description
            })
        })
    });
};
const StyledMultiValue = styled(RsComponents.MultiValue).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})`
  --tag-border-color: var(--tag-surface-color);

  border-radius: var(--border-radius-default);
  margin: var(--spacing-01) 0;
  padding: 0;
  border: 2px solid var(--tag-border-color);
  background: var(--tag-surface-color);
  color: var(--tag-color);
  font-size: var(--font-size-sm);
  line-height: var(--spacing-05);
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;

  :global(:root[data-new-theme-enabled='true']) & {
    border-radius: var(--border-radius-default);
    box-sizing: border-box;
    height: var(--height-sm);
    min-height: var(--height-sm);
    max-height: var(--height-sm);
    margin: 0;
    padding: var(--padding-xs) var(--padding-01);
    gap: var(--padding-xs);
  }
  .ozone-select__multi-value__label {
    border-radius: 0px;
  }

  &:focus {
    --tag-border-color: var(--blue-60);
  }

  &.disabled,
  &[disabled] {
    --tag-surface-color: var(--gray-10);
    --tag-color: var(--gray-30);
  }

  ${({ color })=>css`
    --tag-surface-color: var(--ozone-${color}-surface);
    --tag-color: var(--ozone-${color});
  `};

  cursor: ${ifProp('onClick', 'pointer', 'initial')};
`;
const StyledSingleValue = styled(RsComponents.SingleValue).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})``;
export const SingleUserValue = ({ data, ...props })=>{
    var _data_tagLabel;
    return /*#__PURE__*/ _jsx("span", {
        "data-cy": "select.field.options",
        children: /*#__PURE__*/ _jsx(StyledSingleValue, {
            ...props,
            children: /*#__PURE__*/ _jsx(UserTag, {
                imageUrl: data.imageUrl,
                color: data.color,
                userStatus: data === null || data === void 0 ? void 0 : data.userStatus,
                label: data.__isNew__ ? data.value : (_data_tagLabel = data.tagLabel) !== null && _data_tagLabel !== void 0 ? _data_tagLabel : data.label,
                hideAvatar: data.hideAvatar
            })
        })
    });
};
export const MultiValue = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(MultiValueTagWrapper, {
        "data-cy": `tag-multi-value-${data.label}`,
        children: /*#__PURE__*/ _jsx(StyledMultiValue, {
            color: (data === null || data === void 0 ? void 0 : data.color) || 'gray',
            ...props,
            className: classNames({
                disabled: data.active === false
            })
        })
    });
};
const StyledMultiValueLabel = styled(RsComponents.MultiValueLabel).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})`
  flex: 1;
  min-width: 0;
  overflow: hidden;

  :global(:root[data-new-theme-enabled='true']) & {
    display: flex;
    align-items: center;
    padding: 0 !important;
    margin: 0;
    min-height: 0;
  }
`;
const MultiValueLabelRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--padding-xs);
  min-width: 0;
  max-height: 100%;
`;
const MultiValueLabelText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-sm);
  line-height: var(--spacing-05);
`;
export const MultiValueLabel = (props)=>{
    var _data_tagLabel;
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledMultiValueLabel, {
        ...props,
        children: /*#__PURE__*/ _jsxs(MultiValueLabelRow, {
            children: [
                !(data === null || data === void 0 ? void 0 : data.hideAvatar) && /*#__PURE__*/ _jsx(Avatar, {
                    size: "small",
                    src: data.imageUrl,
                    name: data.__isNew__ ? data.value : data.label,
                    userStatus: data === null || data === void 0 ? void 0 : data.userStatus
                }),
                /*#__PURE__*/ _jsx(MultiValueLabelText, {
                    children: (_data_tagLabel = data.tagLabel) !== null && _data_tagLabel !== void 0 ? _data_tagLabel : data.label
                })
            ]
        })
    });
};
const StyledMultiValueRemove = styled(RsComponents.MultiValueRemove).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})`
  flex-shrink: 0;
`;
const MultiValueRemove = ({ data, ...props })=>{
    var _props_selectProps;
    const isDisabled = Boolean((props === null || props === void 0 ? void 0 : (_props_selectProps = props.selectProps) === null || _props_selectProps === void 0 ? void 0 : _props_selectProps.isDisabled) || (data === null || data === void 0 ? void 0 : data.isOptionDisabled));
    return isDisabled ? null : /*#__PURE__*/ _jsx(StyledMultiValueRemove, {
        ...props,
        children: /*#__PURE__*/ _jsx(Close16, {})
    });
};
export const StyledTag = styled(TagAtom)`
  ${SingleLineEllipsis};
  display: unset;
`;
export const StyledRSOption = styled(RsComponents.Option).attrs({
    theme: {
        ...defaultTheme,
        borderRadius: 0
    }
})`
  display: flex;
  min-width: 0;
  :root[data-new-theme-enabled='true'] & {
    padding-left: var(--padding-xs);
    padding-right: var(--padding-xs);
  }
`;
export const TagOption = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(StyledRSOption, {
        ...props,
        children: /*#__PURE__*/ _jsx(StyledTag, {
            title: data.label,
            color: data.color,
            "data-cy": `tag-option-${data.label}`,
            children: data.label
        })
    });
};
const StyledOptionWithSelector = styled(RsComponents.Option).attrs({
    theme: {
        ...defaultTheme,
        spacing: defaultTheme.spacing
    }
})`
  :root[data-new-theme-enabled='true'] & {
    padding-left: var(--padding-01);
    padding-right: var(--padding-01);
  }
`;
export const SingleLineLabel = styled.span`
  margin-bottom: 0;
  color: inherit;
  display: block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const OptionWithSelector = (props)=>{
    var _data_label_includes, _data_label, _data_label_includes1, _data_label1;
    const { data } = props;
    if ((data === null || data === void 0 ? void 0 : (_data_label = data.label) === null || _data_label === void 0 ? void 0 : (_data_label_includes = _data_label.includes) === null || _data_label_includes === void 0 ? void 0 : _data_label_includes.call(_data_label, '<p')) && (data === null || data === void 0 ? void 0 : (_data_label1 = data.label) === null || _data_label1 === void 0 ? void 0 : (_data_label_includes1 = _data_label1.includes) === null || _data_label_includes1 === void 0 ? void 0 : _data_label_includes1.call(_data_label1, 'p>'))) {
        return /*#__PURE__*/ _jsx(StyledOptionWithSelector, {
            ...props,
            children: /*#__PURE__*/ _jsx(TaskName, {
                dataCy: `select-option-${data.label}`,
                taskName: data === null || data === void 0 ? void 0 : data.label,
                className: "no-margin"
            })
        });
    }
    return /*#__PURE__*/ _jsx(StyledOptionWithSelector, {
        ...props,
        children: /*#__PURE__*/ _jsx(SingleLineLabel, {
            "data-cy": `select-option-${data.label}`,
            children: data.label
        })
    });
};
const SingleValueRSComponent = styled(RsComponents.SingleValue).attrs({
    theme: {
        ...defaultTheme
    }
})``;
export const TagSingleValue = (props)=>{
    const { data } = props;
    return /*#__PURE__*/ _jsx(SingleValueRSComponent, {
        ...props,
        children: /*#__PURE__*/ _jsxs(TagAtom, {
            color: data.color,
            "data-cy": `tag-single-value-${data.label}`,
            className: classNames({
                disabled: data.active === false
            }),
            children: [
                (data === null || data === void 0 ? void 0 : data.deleted) ? /*#__PURE__*/ _jsx(TrashCan16, {}) : null,
                data.label
            ]
        })
    });
};
export const CreatableSelect = ({ className, components = {}, ...props })=>{
    const { type, showMenuOnOpen } = props;
    let customComponents = {
        DropdownIndicator: !showMenuOnOpen && (()=>null),
        IndicatorSeparator: !showMenuOnOpen && (()=>null),
        ClearIndicator,
        Control,
        MultiValueRemove
    };
    if (type === 'user') {
        customComponents = {
            ...customComponents,
            Option: AvatarOption,
            SingleValue: SingleUserValue,
            MultiValue,
            MultiValueLabel
        };
    } else if (type === 'tag') {
        customComponents = {
            ...customComponents,
            Option: TagOption,
            SingleValue: TagSingleValue,
            MultiValue
        };
    }
    return /*#__PURE__*/ _jsx(ReactCreatableSelect, {
        className: classNames(`${selectPrefix}-container`, className),
        classNamePrefix: selectPrefix,
        theme: (theme)=>{
            const baseTheme = theme !== null && theme !== void 0 ? theme : defaultTheme;
            return {
                ...baseTheme,
                borderRadius: 0,
                colors: {
                    ...baseTheme.colors,
                    primary: 'var(--primary-color)'
                },
                spacing: baseTheme.spacing
            };
        },
        components: {
            ...customComponents,
            ...components
        },
        ...props
    });
};
export const AsyncCreatableSelect = ({ className, components = {}, ...props })=>{
    const { type, showMenuOnOpen } = props;
    let customComponents = {
        DropdownIndicator: !showMenuOnOpen && (()=>null),
        IndicatorSeparator: !showMenuOnOpen && (()=>null),
        ClearIndicator,
        Control,
        MultiValueRemove
    };
    if (type === 'user') {
        customComponents = {
            ...customComponents,
            Option: AvatarOption,
            SingleValue: SingleUserValue,
            MultiValue,
            MultiValueLabel
        };
    } else if (type === 'tag') {
        customComponents = {
            ...customComponents,
            Option: TagOption,
            SingleValue: TagSingleValue,
            MultiValue
        };
    }
    const loadOptionsRef = useRef(props.loadOptions);
    const pendingResolveRef = useRef(null);
    loadOptionsRef.current = props.loadOptions;
    const debouncedLoadRef = useRef(debounce((input)=>{
        const resolve = pendingResolveRef.current;
        loadOptionsRef.current(input).then((options)=>{
            resolve === null || resolve === void 0 ? void 0 : resolve(options);
        }).catch(()=>{
            resolve === null || resolve === void 0 ? void 0 : resolve([]);
        });
    }, 300));
    const loadOptions = (input)=>new Promise((resolve)=>{
            if (pendingResolveRef.current) {
                pendingResolveRef.current([]);
            }
            pendingResolveRef.current = resolve;
            debouncedLoadRef.current(input);
        });
    return /*#__PURE__*/ _jsx(ReactAsyncCreatableSelect, {
        className: classNames(`${selectPrefix}-container`, className),
        classNamePrefix: selectPrefix,
        theme: (theme)=>({
                ...theme,
                borderRadius: 0,
                colors: {
                    ...theme.colors,
                    primary: 'var(--primary-color)'
                }
            }),
        components: {
            ...customComponents,
            ...components
        },
        ...props,
        loadOptions: loadOptions
    });
};
const useFilterOptions = (value)=>{
    return useCallback((option, rawInput)=>{
        var _rawInput_trim, _rawInput_trim1, _value_some, _option_label_toLowerCase_includes, _option_label_toLowerCase, _option_label, _option_data;
        const inputIsNotEmpty = (rawInput === null || rawInput === void 0 ? void 0 : (_rawInput_trim1 = rawInput.trim) === null || _rawInput_trim1 === void 0 ? void 0 : (_rawInput_trim = _rawInput_trim1.call(rawInput)) === null || _rawInput_trim === void 0 ? void 0 : _rawInput_trim.length) > 0;
        const isSelected = !!(value === null || value === void 0 ? void 0 : (_value_some = value.some) === null || _value_some === void 0 ? void 0 : _value_some.call(value, (val)=>(val === null || val === void 0 ? void 0 : val.value) === (option === null || option === void 0 ? void 0 : option.value)));
        const searchFilter = option === null || option === void 0 ? void 0 : (_option_label = option.label) === null || _option_label === void 0 ? void 0 : (_option_label_toLowerCase = _option_label.toLowerCase()) === null || _option_label_toLowerCase === void 0 ? void 0 : (_option_label_toLowerCase_includes = _option_label_toLowerCase.includes) === null || _option_label_toLowerCase_includes === void 0 ? void 0 : _option_label_toLowerCase_includes.call(_option_label_toLowerCase, rawInput === null || rawInput === void 0 ? void 0 : rawInput.toLowerCase());
        if ((option === null || option === void 0 ? void 0 : (_option_data = option.data) === null || _option_data === void 0 ? void 0 : _option_data.userStatus) === UserStatus.Inactive) {
            return isSelected && searchFilter || inputIsNotEmpty && searchFilter;
        }
        return searchFilter;
    }, [
        value
    ]);
};
export const BaseReactSelect = /*#__PURE__*/ forwardRef(({ className, components = {}, ...props }, ref)=>{
    const { value, type = 'basic' } = props;
    const filterOptions = useFilterOptions(value);
    const translate = useTranslate();
    let customComponents = {
        DropdownIndicator,
        ClearIndicator,
        Control,
        MultiValueRemove,
        Option: OptionWithSelector
    };
    if (type === 'user') {
        customComponents = {
            ...customComponents,
            Option: AvatarOption,
            SingleValue: SingleUserValue,
            MultiValue,
            MultiValueLabel
        };
    } else if (type === 'tag') {
        customComponents = {
            ...customComponents,
            Option: TagOption,
            SingleValue: TagSingleValue,
            MultiValue
        };
    }
    /* TODO:: Remove this duplicate and make it into single. Note: I am stupidly sleepy while writing this component. So just POC implementation. */ return /*#__PURE__*/ _jsx(ReactSelect, {
        ref: ref,
        className: classNames('ozone-select-container', className),
        classNamePrefix: "ozone-select",
        theme: (theme)=>{
            const baseTheme = theme !== null && theme !== void 0 ? theme : defaultTheme;
            return {
                ...baseTheme,
                borderRadius: 0,
                colors: {
                    ...baseTheme.colors,
                    primary: 'var(--primary-color)'
                },
                spacing: baseTheme.spacing
            };
        },
        components: {
            ...customComponents,
            ...components
        },
        placeholder: translate('select_with_ellipse'),
        ...props,
        filterOption: type === 'user' ? (option, rawInput)=>{
            return filterOptions(option, rawInput);
        } : createFilter({
            matchFrom: 'any',
            stringify: (option)=>`${option.label}`
        })
    });
});
// Export Select as BaseReactSelect for backward compatibility and styled-component interpolation
export const Select = BaseReactSelect;
export const AsyncSelect = /*#__PURE__*/ forwardRef(({ className, components = {}, ...props }, ref)=>{
    const { value, type = 'basic' } = props;
    const filterOptions = useFilterOptions(value);
    const translate = useTranslate();
    let customComponents = {
        DropdownIndicator,
        ClearIndicator,
        Control,
        MultiValueRemove,
        Option: OptionWithSelector
    };
    if (type === 'user') {
        customComponents = {
            ...customComponents,
            Option: AvatarOption,
            SingleValue: SingleUserValue,
            MultiValue,
            MultiValueLabel
        };
    } else if (type === 'tag') {
        customComponents = {
            ...customComponents,
            Option: TagOption,
            SingleValue: TagSingleValue,
            MultiValue
        };
    }
    // Store latest loadOptions in a ref so the debounced callback always
    // calls the current version, not the one captured on first render.
    const loadOptionsRef = useRef(props.loadOptions);
    const pendingResolveRef = useRef(null);
    loadOptionsRef.current = props.loadOptions;
    const debouncedLoadRef = useRef(debounce((input)=>{
        const resolve = pendingResolveRef.current;
        loadOptionsRef.current(input).then((options)=>{
            resolve === null || resolve === void 0 ? void 0 : resolve(options);
        }).catch(()=>{
            resolve === null || resolve === void 0 ? void 0 : resolve([]);
        });
    }, 300));
    // with the ref in place, we can call the function and get the latest version of the function
    // without creating a new function on every render. Superseded calls are resolved with [] so
    // no promise is left pending when the user types again before the debounce fires.
    const loadOptions = (input)=>new Promise((resolve)=>{
            if (pendingResolveRef.current) {
                pendingResolveRef.current([]);
            }
            pendingResolveRef.current = resolve;
            debouncedLoadRef.current(input);
        });
    /* TODO:: Remove this duplicate and make it into single. Note: I am stupidly sleepy while writing this component. So just POC implementation. */ return /*#__PURE__*/ _jsx(AsyncReactSelect, {
        ref: ref,
        className: classNames('ozone-select-container', className),
        classNamePrefix: "ozone-select",
        theme: (theme)=>{
            const baseTheme = theme !== null && theme !== void 0 ? theme : defaultTheme;
            return {
                ...baseTheme,
                borderRadius: 0,
                colors: {
                    ...baseTheme.colors,
                    primary: 'var(--primary-color)'
                },
                spacing: baseTheme.spacing
            };
        },
        components: {
            ...customComponents,
            ...components
        },
        placeholder: translate('select_with_ellipse'),
        ...props,
        loadOptions: loadOptions,
        filterOption: type === 'user' ? (option, rawInput)=>{
            return filterOptions(option, rawInput);
        } : createFilter({
            matchFrom: 'any',
            stringify: (option)=>`${option.label}`
        })
    });
});
AsyncSelect.displayName = 'AsyncSelect';
export const CurrencySelect = (props)=>/*#__PURE__*/ _jsx(Select, {
        components: {
            Option: CurrencyOption
        },
        ...props
    });
export const UserComponents = {
    Option: AvatarOption,
    SingleValue: SingleUserValue,
    MultiValue,
    MultiValueLabel
};
export const TagComponents = {
    Option: TagOption,
    SingleValue: TagSingleValue,
    MultiValue
};
